import React from "react";
import "./Heading.css";

import Avatar from "../Contents/dishant.jpg";
function Heading() {
  return (
    <>
      <div className="head" style={{ height: "100vh" }}>
        <nav className="navbar navbar-expand-lg fixed-top" id="mainNav">
          <div className="container">
            <button
              className="navbar-toggler navbar-toggler-right font-weight-bold bg-primary text-white rounded"
              type="button"
              data-toggle="collapse"
              data-target="#navbarResponsive"
              aria-controls="navbarResponsive"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              Menu <i className="fas fa-bars"></i>
            </button>
            <div className="collapse navbar-collapse" id="navbarResponsive">
              <ul className="navbar-nav ml-auto mr-auto">
                <li className="nav-item mx-0 mx-lg-1">
                  <a
                    className="nav-link py-3 px-0 px-lg-3 rounded js-scroll-trigger"
                    href="#page-top"
                  >
                    HOME
                  </a>
                </li>
                <li className="nav-item mx-0 mx-lg-1">
                  <a
                    className="nav-link py-3 px-0 px-lg-3 rounded js-scroll-trigger"
                    href="#projects"
                  >
                    PROJECTS
                  </a>
                </li>
                <li className="nav-item mx-0 mx-lg-1">
                  <a
                    className="nav-link py-3 px-0 px-lg-3 rounded js-scroll-trigger"
                    href="#about"
                  >
                    ABOUT
                  </a>
                </li>
                <li className="nav-item mx-0 mx-lg-1">
                  <a
                    className="nav-link py-3 px-0 px-lg-3 rounded js-scroll-trigger"
                    href="#contact"
                  >
                    CONTACT
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
        <header
          className="masthead bg-head text-white text-center"
          style={{ height: "30vh" }}
        ></header>
        <div
          className="container d-flex align-items-center flex-column"
          style={{ marginTop: "-65px" }}
        >
          {/*<!-- Masthead Avatar Image-->*/}
          <div className="avatar">
            <img className="myimg" src={Avatar} alt="" />
          </div>

          {/* <!-- Masthead Heading--> */}
          <h1 className="masthead-heading mb-0">I'm Dishant Aarak</h1>
          {/* <!-- Icon Divider--> */}
          <div className="divider-custom divider-dark">
            <div className="divider-custom-line"></div>
            <div className="divider-custom-icon">
              <i className="fas fa-star"></i>
            </div>
            <div className="divider-custom-line"></div>
          </div>
          {/* <!-- Masthead Subheading--> */}
          <p
            className="pre-wrap masthead-subheading mb-0 typewrite"
            id="text"
            data-period="2000"
            data-type='["I am Creative.", "I Love Sketch.", "I Love to Develop." ]'
          >
            {" "}
            <span id="wrap"></span>
          </p>
          <a className="btn btn-primary btn-border" href="#about">
            MORE ABOUT ME
          </a>
          <br />
        </div>
      </div>
      <hr />
    </>
  );
}

export default Heading;
